module.exports = __webpack_public_path__ + "img/mission-center.c8d9cf27.png";